<template>
    <div
        data-sidepanel="content"
        class="flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden"
    >
        <slot />
    </div>
</template>
